import { freePracticeSessionTypes } from '@actions-constants/index';
import { HOST_TYPE } from '@utils/api-helper/host';

const fetchFreePracticeTopologies = ({
  goalUID,
  subTopic = false,
  isGTP = false
}) => {
  let type = freePracticeSessionTypes.FETCH_FREE_PRACTICE_TOPOLOGIES;
  let endpoint = `v1/quizzes/topology/practice_session_seo_topologies/?parent_uid=${goalUID}`;
  if (subTopic) {
    endpoint += '&topic_practice_section=True';
    type = freePracticeSessionTypes.FETCH_FREE_PRACTICE_TOPOLOGY_LIST;
  }
  return {
    type,
    endpoint,
    method: 'get',
    hostType: HOST_TYPE.BACKEND_API_HOST,
    isGTP
  };
};

export const fetchFreePracticeQuestions = ({ topicUID, goalUID, isGTP }) => {
  const endpoint = isGTP
    ? `v2/quizzes/question/get_gtp_questions/?uid=${topicUID}&goal_uid=${goalUID}`
    : `v2/quizzes/question/get_questions/?uid=${topicUID}`;

  return {
    type: freePracticeSessionTypes.FETCH_FREE_PRACTICE_QUESTIONS,
    endpoint,
    method: 'get'
  };
};

export default fetchFreePracticeTopologies;

export const updateFreePracticeQuestionCount = ({ goalUID }) => ({
  type: freePracticeSessionTypes.UPDATE_FREE_PRACTICE_QUESTION_COUNT,
  endpoint: 'v1/quizzes/free-practice/learner-submission-count/',
  method: 'post',
  data: {
    goal_uid: goalUID
  }
});
